import { CollectionModel, createThunk, model } from 'mst-collection';

import { UserModel } from './UserModel';
import { Api, schemas } from '@api';

export class UserCollection extends CollectionModel(UserModel) {
  fetchById = createThunk((id: number) => {
    return async function fetchById(this: UserCollection, flow) {
      const res = await Api.Profile.getSharedDataById({ id });

      flow.merge(res.data, schemas.UserSchema);

      const user = this.get(id);

      return user;
    };
  });

  fetchByIds = createThunk((ids: number[]) => {
    return async function fetchByIds(this: UserCollection, flow) {
      const res = await Api.Profile.getSharedData(ids);

      flow.merge(res.data, schemas.UserListSchema);

      const users = res.data.map((user) => this.get(user.id));

      return users;
    };
  });
}

export const UserCollectionModel = model(UserCollection);
